import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTexts } from "../api/text";
import { setGameTexts } from "../redux/actions";

/**
 * Devuelve los textos del juego desde la caché de Redux.
 * Si no están en caché, los pide al API y los guarda (evitando parpadeo en páginas siguientes).
 * loading = true hasta que tengamos los textos (solo la primera vez por juego).
 */
export function useGameTexts(gameId) {
	const dispatch = useDispatch();
	const [fetched, setFetched] = useState(false);
	const texts = useSelector((state) =>
		gameId && state.gameTexts?.[gameId] ? state.gameTexts[gameId] : {}
	);
	const hasTexts = Object.keys(texts).length > 0;
	const loading = !!gameId && !hasTexts && !fetched;
	const ready = !gameId || hasTexts || fetched;

	useEffect(() => {
		setFetched(false);
	}, [gameId]);

	useEffect(() => {
		if (!gameId) {
			setFetched(true);
			return;
		}
		if (Object.keys(texts).length > 0) {
			setFetched(true);
			return;
		}
		getTexts({ game: gameId })
			.then((res) => {
				if (res?.status === 200 && Array.isArray(res?.data)) {
					const map = res.data.reduce(
						(acc, t) => ({ ...acc, [t.key]: t.value }),
						{}
					);
					dispatch(setGameTexts(gameId, map));
				}
			})
			.catch(() => {})
			.finally(() => setFetched(true));
	}, [gameId, dispatch, texts]);

	return { texts, loading, ready };
}
